import { apiGet } from 'helpers/ApiHelper';

import Auth from 'j-toker';
import * as notifications from './notificationActions';
import { markMessagesAsRead } from './chatActions';

export function closeMaintenanceDialog() {
  return {
    type: 'CLOSE_MAINTENANCE_DIALOG',
  };
}

export function openMaintenanceDialog() {
  return {
    type: 'OPEN_MAINTENANCE_DIALOG',
  };
}

export function setTenancyStatus(tenancyStatus) {
  return {
    type: 'SET_DASHBOARD_LAYOUT',
    hasApplication: tenancyStatus.is_applying,
    currentTenant: tenancyStatus.is_current_tenant,
    tenantOverview: tenancyStatus.tenant_overview,
    moveOutDetails: tenancyStatus.move_out_details,
    badgeIconForEvents: tenancyStatus.number_of_events,
    moveOut: tenancyStatus.moving_out,
    hasPoll: tenancyStatus.has_poll,
    pollDetails: tenancyStatus.poll_details,
    propertyType: tenancyStatus.property_type,
    applicants: tenancyStatus.applicants,
    coapplicantsInApplication: tenancyStatus.coapplicants_in_application,
    activeApplicationID: tenancyStatus.active_application_id,
    leaseStartDate: tenancyStatus.lease_start_date,
    address: tenancyStatus.address,
    portalLinks: tenancyStatus.portal_links,
    bannerMessage: tenancyStatus.banner_message,
    landlordMaintenaceRequestLink: tenancyStatus.landlord_maintenance_request_link,
  };
}

export function unreadMessages(conversationID, unread_messages) {
  return dispatch => {
    if (conversationID && unread_messages === 0) {
      dispatch(markMessagesAsRead(conversationID));
    }

    dispatch({
      type: 'MESSAGES::SET_UNREAD_MESSAGES',
      unread_messages,
    });
  };
}

export function getTenancyStatus() {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + '/leads/tenancy_status')
        .done(response => {
          dispatch(setTenancyStatus(response.tenancy_status));
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}
